module.exports = __webpack_public_path__ + "static/media/naturgy02.2fbf3d0d.png";